"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDVSString = exports.useDVSNumber = exports.useDVSBoolean = exports.useDVSValue = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var useDVSValue = function (dvName, defaultValue) {
    var client = (0, react_1.useContext)(context_1.DVSClientContext).client;
    if (client === null) {
        // TODO: Log this error to sentry: WP-1969
        // tslint:disable-next-line:no-console
        console.warn('useDVSValue hook requires a wrapping DVSClientProvider.', {
            dvName: dvName,
            defaultValue: defaultValue,
        });
        return defaultValue;
    }
    return client.getValue(dvName, defaultValue);
};
exports.useDVSValue = useDVSValue;
/**
 * `useDVSBoolean` is a hook for accessing resolved dynamic values using the
 * DVSClientContext.
 *
 * @param dvName The DV to evaluate
 * @param defaultValue A safe fallback value
 */
var useDVSBoolean = function (dvName, defaultValue) {
    return (0, exports.useDVSValue)(dvName, defaultValue);
};
exports.useDVSBoolean = useDVSBoolean;
/**
 * `useDVSNumber` is a hook for accessing resolved dynamic values using the
 * DVSClientContext.
 *
 * @param dvName The DV to evaluate
 * @param defaultValue A safe fallback value
 */
var useDVSNumber = function (dvName, defaultValue) {
    return (0, exports.useDVSValue)(dvName, defaultValue);
};
exports.useDVSNumber = useDVSNumber;
/**
 * `useDVSString` is a hook for accessing resolved dynamic values using the
 * DVSClientContext.
 *
 * @param dvName The DV to evaluate
 * @param defaultValue A safe fallback value
 */
var useDVSString = function (dvName, defaultValue) {
    return (0, exports.useDVSValue)(dvName, defaultValue);
};
exports.useDVSString = useDVSString;
//# sourceMappingURL=hooks.js.map